import type { TenantSummary } from '@/api/types'

function initials(name: string): string {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0]?.toUpperCase() ?? '')
      .join('') || '?'
  )
}

/** The tenant's logo, or a monogram in the accent colour when there is none. */
export function TenantMark({ tenant, size = 32 }: { tenant: Pick<TenantSummary, 'name' | 'logoUrl'> | undefined; size?: number }) {
  if (tenant?.logoUrl) {
    return <img className="ci-tenant-mark" src={tenant.logoUrl} alt="" width={size} height={size} />
  }
  return (
    <span className="ci-tenant-mark" style={{ width: size, height: size }} aria-hidden="true">
      {initials(tenant?.name ?? '')}
    </span>
  )
}
